import styles from "./index.module.scss";
import { NavCreateSvg, NavMyCreationsSvg } from "@/assets/icons";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useCommonStore, useUserStore } from "@/stores";
// import FTAnalytic from "@/analyze/FTAnalytic";

const Navigation = () => {
  const { t } = useTranslation();
  const isMobile = useCommonStore(state => state.isMobile);
  const isLogin = useUserStore(state => state.getters.isLogin);
  const showLogin = useUserStore(state => state.showLogin);
  const userInfo = useUserStore(state => state.userInfo);

  const navList = [
    {
      key: "create",
      icon: <NavCreateSvg></NavCreateSvg>,
      title: t("nav_create"),
      isActive: true,
    },
    {
      key: "my_creations",
      icon: <NavMyCreationsSvg></NavMyCreationsSvg>,
      title: t("nav_my_creations"),
      isActive: false,
      onClick: () => {
        // 埋点（点击）
        // FTAnalytic.addAnalytic({
        //   type: 'ev',
        //   action: 'fotor_web$click_up$swap_project_page_features',
        //   label: {
        //     button_position: "my creation",
        //     project_type: PROJECT_TYPE,
        //   },
        // });

        if (isLogin) {
          window.open(`${process.env.REACT_APP_BASE_URL}/cloud/creations/?type=mimic`);
        } else {
          showLogin({
            isSignIn: true,
            options: {
              position: 'my creation',
            },
            isShowScenses: true,
            callback: () => {
              window.open(`${process.env.REACT_APP_BASE_URL}/cloud/creations/?type=mimic`);
            }
          });
        }
      }
    },
  ]

  return (
    <div className={styles["navigation"]}>
      <ul
        className={styles["nav_list"]}
      >
        {navList.map(item => (
          <li 
            key={item.key}
            className={clsx(
              styles["nav_item"],
              item.isActive && styles["active"]
            )}
          >
            {isMobile && item.icon}
            <button 
              className={styles["nav_button"]}
              onClick={() => item.onClick?.()}
            >
              <span
                className={styles["nav_title"]}
              >{item.title}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Navigation;